import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let settings = Object.fromEntries(
      data.leads_settings.map(setting => [setting.key, setting.value])
    )

    if (!('locationWhitelist' in settings)) {
      settings['locationWhitelist'] = []
    }

    let setting_ids = Object.fromEntries(
      data.leads_settings.map(setting => [setting.key, setting.id])
    )

    if (settings?.showProgressBar == null) {
      // we need to default this as it might not exist
      settings.showProgressBar = true
    }

    if (settings?.themeOverride && Object.keys(settings.themeOverride).length) {
      settings.themeOverride.dark = settings.themeOverride['colors.theme.dark']
      settings.themeOverride.light =
        settings.themeOverride['colors.theme.light']
      settings.themeOverride.main = settings.themeOverride['colors.theme.main']
    }

    return {
      ...settings,
      setting_ids,
      level: data.leads_configurations_by_pk.organization.level,
      questions: data.leads_questions,
      app_id: data.leads_configurations_by_pk.app_id,
      apps: data.apps_apps,
    }
  }, [data])
}
